// extracted by mini-css-extract-plugin
export default {"text":"TooltipText_text__QYrb5"};